import cn from 'clsx';
import { type TFunction, type TransComponent } from '@pkgs/components/providers/AppContextProvider';
import { SignInDialog, type SignInDialogProps } from '@ev-tech/user-account-modules';
import { CountryCode, Language } from '@ev-tech/search-modules-api';

import { useUserAccountStatusMessages } from './useUserAccountStatusMessages';

import styles from './UserAccountModal.module.css';

export type UserAccountSignInDialogProps = {
  tFunc: TFunction;
  transComponent: TransComponent;
  countryCode?: string;
  language?: string;
  trigger?: SignInDialogProps['trigger'];
  tracking: SignInDialogProps['tracking'];
  className?: string;
};

export const UserAccountSignInDialog = ({
  tFunc,
  transComponent: TransComponent,
  countryCode = CountryCode.DE,
  language = Language.en,
  trigger,
  tracking,
  className,
}: UserAccountSignInDialogProps) => {
  const statusMessageCallbacks = useUserAccountStatusMessages({ tFunc, transComponent: TransComponent });

  return (
    <div className={cn(styles.userAccountModalContent, className)}>
      <SignInDialog
        tFunc={tFunc}
        initialStep="signIn"
        country={countryCode.toLowerCase()}
        language={language}
        trigger={trigger}
        tracking={{
          ...tracking,
          pageType: tracking?.pageType ?? '',
          templateType: tracking?.templateType ?? '',
          shopId: tracking?.shopId ?? '',
        }}
        {...statusMessageCallbacks}
      />
    </div>
  );
};
